import { lazy } from "react";
import { StepType } from "@/context/app-context";

export const steps: StepType[] = [
  {
    component: lazy(() => import("@/components/steps/ChooseProfileType")),
  },
  {
    component: lazy(() => import("@/components/steps/EnterProfileUsername")),
  },
  {
    component: lazy(() => import("@/components/steps/ConfirmProfile")),
  },
  {
    component: lazy(() => import("@/components/steps/SearchProfile")),
  },
  {
    component: lazy(() => import("@/components/steps/AnalyticsProfile")),
  },
  {
    component: lazy(() => import("@/components/steps/ReportProfile")),
  },
  {
    component: lazy(() => import("@/components/steps/Checkout")),
  },
];

export enum Step {
  ChooseProfileType = 0,
  EnterProfileUsername = 1,
  ConfirmProfile = 2,
  SearchProfile = 3,
  AnalyticsProfile = 4,
  ReportProfile = 5,
  Checkout = 6,
}
